import moment from 'moment';
import React from 'react';
import { Card, Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import PropagateLoader from 'react-spinners/PropagateLoader';

export default function NotificationDetails(props) {

    const { modalLoading, notifyDetails, setNotifyDetails, bool, setBool } = props;

    const data = useSelector(state => state.notificationDetails && state.notificationDetails.data && state.notificationDetails.data.data)
    // console.log(data)

    const userRole = JSON.parse(localStorage.getItem('user_data'));
    const role = userRole && userRole.vrole_name

    const handleClose = () => {
        setBool(!bool)
        setNotifyDetails(false)
    }

    return (
        <>
            <Modal show={notifyDetails} onHide={handleClose} size='lg' backdrop="static" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {modalLoading ?
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                        :
                        <Card className='mb-2'>
                            <Card.Body className='d-flex justify-content-between align-items-center' style={{ padding: '0.5rem' }} >
                                <div className="me-auto">
                                    {role == 'Instructor' ?
                                        <div className="fw-bold" style={{ color: 'rgba(34, 98, 198, 0.6)' }}>{`${data?.UserData?.vemp_fname} - (${data?.UserData?.vemp_company_code})`}</div>
                                        : ''
                                    }
                                    <div className="fw-bold">{data?.UserNotification?.notification_title}</div>
                                    {data?.UserNotification?.notification_message}
                                </div>
                                <div className="fw-bold" style={{ fontSize: '20px', color: '#2262C6' }}>{data?.UserNotification?.createdAt && moment(data?.UserNotification?.createdAt).format('DD/MM/YYYY')}</div>
                            </Card.Body>
                        </Card>
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}